import React, { useState } from 'react'
import { Button, Steps, Spin, message, Alert, Card } from 'antd'
import WrappedAiCourseForm from './AiCourseForm'
import ContentChoiceStep from './ContentChoiceModal'
import { useTranslation } from 'react-i18next'
import { api } from '../../../services'

const Step = Steps.Step

const defaultErrorObj = {
  hasError: false,
  msg: ''
}
const AiCourseCreationModal = ({
  visible,
  onCancel,
  onFormSubmit,
  loading,
  courseTitle = '',
  courseId,
  isFromKnowledgeCenter,
  language,
  ...props
}) => {
  const [currentStep, setCurrentStep] = useState(0)
  const [formValues, setFormValues] = useState(null)
  const [selectedDocuments, setSelectedDocuments] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(defaultErrorObj)

  // Step 1: handle form submit, go to next step
  const handleFormSubmit = values => {
    setFormValues(values)
    setCurrentStep(1)
  }

  // Step 2: handle document selection and final submit
  const handleDocumentSelect = (selectedDocumentPaths = []) => {
    setSelectedDocuments(selectedDocumentPaths)
    handleFinalSubmit(formValues, selectedDocumentPaths)
  }

  //   const handleFinalSubmit = (values, documentPaths) => {
  //     // You may want to move the API logic here from AiCourseForm
  //     // For now, just call onFormSubmit
  //     onFormSubmit && onFormSubmit(values, documentPaths)
  //     setIsSubmitting(false)
  //     setCurrentStep(0)
  //     setFormValues(null)
  //     setSelectedDocuments([])
  //     onCancel && onCancel()
  //   }

  const handleFinalSubmit = files => {
    setIsSubmitting(true)

    const {
      courseTitle,
      learningObjective,
      standardDetails,
      standard,
      industry,
      industrySpecific,
      duration
    } = formValues

    api.courses
      .patchUpdateCourse(courseId, {
        duration: duration
      })
      .catch(err => {
        console.error(err)
      })

    api.courses
      .askAiCourseCreation({
        params: {
          prompt: JSON.stringify({
            course_title: courseTitle,
            learning_objective: learningObjective,
            standard_details: standardDetails,
            standard: standard,
            industry: industry,
            industry_specific: industrySpecific,
            duration: duration + ' minutes',
            course_id: courseId
          }),
          context: [],
          language: language
        }
      })
      .then(res => {
        setIsSubmitting(false)
        onFormSubmit(formValues, res.data.body[0], files)
        setError(defaultErrorObj)
      })
      .catch(err => {
        setIsSubmitting(false)
        setError({ hasError: true, msg: err.message })
      })
  }

  const handleBack = () => {
    setCurrentStep(currentStep - 1)
  }

  const handleModalCancel = () => {
    setCurrentStep(0)
    setFormValues(null)
    setSelectedDocuments([])
    onCancel && onCancel()
  }
  const { t } = useTranslation()

  console.log('AiCourseCreationModal render, currentStep:', currentStep)

  return (
    <div
      style={{
        padding: 24,
        background: '#fff',
        borderRadius: 8,
        maxWidth: 800,
        margin: '0 auto'
      }}
    >
      <Steps current={currentStep} style={{ marginBottom: 0 }}>
        <Step title={t('v4:course_info')} />
        <Step title={t('v4:content_selection')} />
      </Steps>

      <Card style={{ marginTop: 20 }}>
        <Spin spinning={isSubmitting || loading}>
          {error.hasError && (
            <Alert
              message={error.msg}
              type="error"
              showIcon
              style={{ marginTop: 20 }}
            />
          )}

          {currentStep === 0 && (
            <WrappedAiCourseForm
              {...props}
              courseTitle={courseTitle}
              courseId={courseId}
              isFromKnowledgeCenter={isFromKnowledgeCenter}
              loading={false}
              onFormSubmit={handleFormSubmit}
              formValues={formValues}
            />
          )}
          {currentStep === 1 && (
            <div>
              <ContentChoiceStep
                onCancel={handleBack}
                onSelect={handleDocumentSelect}
                handleBack={handleBack}
                handleFinalSubmit={handleFinalSubmit}
                isSubmitting={isSubmitting}
              />
            </div>
          )}
        </Spin>
      </Card>
    </div>
  )
}

export default AiCourseCreationModal
